module.exports = __webpack_public_path__ + "data/skeeballPlay.72d146137c00860b4f30d01f7383c5ec.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=data/[name].[hash].json!./app/assets/image/GA/skeeballPlay.json
// module id = 350
// module chunks = 0